import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-inner">
        <div className="footer-col">
          <div className="footer-title">FOLLOW US</div>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            Instagram
          </a>
        </div>

        <div className="footer-col sep">
          <div className="footer-title">OUR FINE PRINT</div>
          <Link to="/returns" onClick={toTop}>
            Shipping & Return Policy
          </Link>

          <Link to="/privacy" onClick={toTop}>
            Privacy & Terms
          </Link>
        </div>

        <div className="footer-col sep">
          <div className="footer-title">NEED HELP?</div>

          <Link to="/contact" onClick={toTop}>
            Contact
          </Link>
        </div>

        <div className="footer-col newsletter sep">
          <div className="footer-title">KEEP IN TOUCH</div>

          <p>main@ownmarketplace.xyz</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
